var map = {
	"./demos/basic/index.ts": 46432,
	"./demos/close/index.ts": 50818,
	"./demos/duration/index.ts": 1377,
	"./demos/events/index.ts": 90144,
	"./demos/hideClose/index.ts": 35251,
	"./demos/icon/index.ts": 21858,
	"./demos/position/index.ts": 38020,
	"./demos/types/index.ts": 30087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98770;